import React, { useMemo, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Box, Grid, Typography, Button } from "@mui/material";
import { ToolContext } from "../../../../../core/context/ToolContext";

export const Body = () => {
    const nav = useHistory()
    const {reconciliation_state, session_state} = useContext(ToolContext)
    const {sessionData} =session_state
    const {isToReconcile, toReconcileList, reconciledList, toReconcile} = reconciliation_state
    const listData = useMemo(() => {
        const data = (isToReconcile.data ? toReconcileList.data : reconciledList.data) || [];

        const handleClick = (item) =>{
            toReconcile.set(prev => ({...prev, date: item.date, branch_id: item.branch_id,  branch_sales_id: item.id }));
            nav.push("/reconciliationreport/form");
        }

        return data.map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                <Box borderRadius={3} boxShadow={4} p={2} display="flex" flexDirection="column" bgcolor="#FFFFFF">
                    <Box mb={1}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography fontSize={13}>Status:</Typography>
                            <Box px={2} py={0.5} borderRadius={2}bgcolor={item.status === 1 || item.status === 2 ? "warning.main" : item.status === 3 ? "info.main" : item.status === 4 ? "success.main" : "grey.300"} color="#FFFFFF" fontWeight={600} fontSize={12}>
                                <Typography fontSize={13}>{item.status === 1 ? "To Reconcile" : item.status === 2 ? "For Review" : item.status === 3 ? "For Approval" : "Approved"}</Typography>
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between">
                            <Typography fontSize={13}>Branch Sale #:</Typography>
                            <Typography fontWeight={600} fontSize={12}>{item.id}</Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between">
                            <Typography fontSize={13}>Branch :</Typography>
                            <Typography fontWeight={600} fontSize={12}>{item.branch_name}</Typography>
                        </Box>

                        <Box display="flex" justifyContent="space-between">
                            <Typography fontSize={13}>Date:</Typography>
                            <Typography fontWeight={600} fontSize={12}>{item.date}</Typography>
                        </Box>
                    </Box>

                    <Button variant="contained" onClick={() => {handleClick(item)}} fullWidth> View</Button>
                </Box>
            </Grid>
        ));
        // eslint-disable-next-line
    }, [ toReconcileList.data, reconciledList.data, sessionData.data.branch_name, toReconcile,]);

    return <>{listData}</>;
};
